import { Text } from "@sentricmusic/ui";
import { Link, useRouterState } from "@tanstack/react-router";
import { useState } from "react";

import { useUIStateStore } from "@/store/uiStateStore";

import useGetColours from "../helpers/getColours";

function SideNavItem(props) {
  const {
    icon,
    to,
    title,
    exact,
    subtitle,
    disabled,
    id,
  } = props;
  const { highlightColour } = useGetColours();
  const [hovering, setHovering] = useState(false);
  const pathname = useRouterState({ select: s => s.location.pathname });
  const isActive = exact === true
    ? pathname === to
    : pathname === to || (to !== "/" && pathname.startsWith(to.endsWith("/") ? to : `${to}/`));
  const inActiveColour = "#A09E9F";
  const activeStyle = {
    color: isActive ? highlightColour : inActiveColour,
  };
  const isTunecore = useUIStateStore(state => state.isTunecore);

  if (!disabled) {
    return (
      <Link
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        id={id}
        className={`rounded-lg xl:rounded-none m-2 xl:m-0 side-nav-item flex justify-start max-md:justify-center items-center gap-3.5 p-3 pl-2 md:pl-7 xl:pr-7 xl:py-12 z-10 relative ${
          isTunecore
            ? `hover:bg-layer-raised ${isActive ? "bg-layer-raised" : ""}`
            : `hover:bg-layer-disabled ${isActive ? "bg-layer-disabled" : ""}`
        }`}
        to={to}
        style={activeStyle}
      >
        <div
          style={{
            color: hovering || isActive ? highlightColour : inActiveColour,
          }}
          className="block text-xl"
        >
          {icon}
        </div>
        <div className="text-black">
          <Text as="p" className={` text-base font-semibold  ${isTunecore ? "text-white" : "text-black"}`}>{title}</Text>
          <Text as="p" className={`hidden text-sm xs:block font-sentric-alt ${isTunecore ? "text-white" : "text-ink-primary"}`}>{subtitle}</Text>
        </div>
      </Link>
    );
  }

  return (
    <div className={`rounded-lg xl:rounded-none m-2 xl:m-0 flex justify-start gap-3.5 p-3 xl:pl-7 xl:pr-7 xl:py-12 z-10 relative ${
      isTunecore ? "" : "rb-side-nav-item"
    }`}
    >
      <div className="text-2xl lg:text-3xl text-ink-secondary">
        {icon}
      </div>
      <div>
        <Text as="p" className="mb-1 text-base font-semibold text-ink-disabled">{title}</Text>
        <Text as="p" className="hidden xs:block font-sentric-alt text-ink-disabledext-xs">{subtitle}</Text>
      </div>
    </div>
  );
}

export default SideNavItem;
